import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/driverRequestTemplatesActions'
import * as api from '../../api/template'

function* getDriverRequestTemplates(action) {
  try {
    const payload = yield call(api.getDriverRequestTemplates)
    yield put({ type: constants.GET_DRIVER_REQUEST_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_DRIVER_REQUEST_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetDriverRequestTemplates() {
  yield takeLatest(constants.GET_DRIVER_REQUEST_TEMPLATES.ACTION, getDriverRequestTemplates)
}

export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchGetDriverRequestTemplates)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/driverRequestTemplateSaga.js